module.exports = __webpack_public_path__ + "img/section_01.64063ea1.png";